<template>
  <div class="login_box">
    <div v-if="Menu.account" class="flex-start message-box">
      <q-img src="~assets/icons/svg/checkout/lock-icon.svg" class="img-icon" alt="" />
      <span class="message-text">
        {{ $t("login.messageText") }}
      </span>
    </div>

    <MInput
      v-model="phone"
      :label="$t('login.loginName')"
      placeholder="81234567"
      :disabled="disableInput"
      :err-msg="errmsg"
      native-type="tel"
      :filter="(v) => v.replace(/\D+/g, '')"
      @change="e => phone = e.target.value.replace(/^0+/g, '')"
    >
      <template #prepend>
        <div class="prepend" @click="chooseCountryVisible = true">
          <span class="countryIcon">{{
            countryHash[`${countryCode}${countryName}`].icon
          }}</span>
          <span class="countryCode">
            {{ countryHash[`${countryCode}${countryName}`].value }}
          </span>
          <span class="iconfont">&#xe6de;</span>
        </div>
      </template>
    </MInput>
    <template v-if="pageState === 'verify'">
      <MInput
        v-model="captcha"
        :label="$t('login.enterOTP')"
        style="margin-top: 16px"
        :err-msg="verifyErrmsg"
        :filter="(v) => v.replace(/\D+/g, '')"
        :max="4"
      />
      <div class="q-mt-sm font-size-12">
        <div>{{ typeTip }}</div>
        <div v-if="countdownState">
          {{ $t('login.countDown') }}
          <b> {{ $t('login.countDownSeconds', [number / 1000]) }}</b>
        </div>
        <div v-else>
          {{ $t('login.noCode') }}
          <b primary @click="resend">{{ $t('login.reSend') }}</b>
        </div>
      </div>
    </template>
    <template v-if="pageState === 'init'">
      <MButton
        :disabled="!isCheckPass"
        :loading="sending"
        primary
        bold
        class="login_box_submit"
        @click="onSend"
      >
        {{ $t('login.submit') }}
      </MButton>
<!--      <div class="login_box_tips">-->
<!--        <span> {{ $t('login.loginNextMsg1') }} </span>-->
<!--        <a target="_blank" href="https://www.desty.app/terms">-->
<!--          {{ $t('login.terms') }}-->
<!--        </a>-->
<!--        <span> {{ $t('login.and') }} </span>-->
<!--        <a target="_blank" href="https://www.desty.app/privacy">-->
<!--          {{ $t('login.privacy') }}-->
<!--        </a>-->
<!--        <span> Bakmi GM </span>-->
<!--      </div>-->
    </template>
    <BaseLogo />
    <!--ContryDialog-->
    <q-dialog v-model="chooseCountryVisible" position="bottom">
      <div class="chooseCountry pc-width-pull-full">
        <div class="head">
          <p>{{ $t('loginSearchCountry.title') }}</p>
          <span class="close iconfont" @click="chooseCountryVisible = false">
            &#xe6e8;
          </span>
        </div>
        <MInput
          v-model="searchText"
          class="font-size-16 searchText"
          :placeholder="$t('loginSearchCountry.placeholder')"
        >
          <template #prepend>
            <div class="choose-prepend">
              <q-icon size="xs" name="app:googlemapSearch" />
            </div>
          </template>
          <template #after>
            <div class="choose-after">
              <q-icon
                v-if="searchText"
                name="font:dm-close"
                class="closeSearch"
                @click="searchText = ''"
              />
            </div>
          </template>
        </MInput>
        <div class="countryList">
          <template v-for="item in showCountry">
            <p
              :key="`${item.value}${item.name}`"
              :class="{
                countryItem: true,
                curr: item.value === countryCode && countryName === item.name,
              }"
              @click="changeCountry(item)"
            >
              {{ item.icon }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}
              <span class="iconfont">&#xe606;</span>
            </p>
          </template>
        </div>
      </div>
    </q-dialog>
  </div>
</template>
<script setup>
import MInput from 'src/components/MInput/index.vue';
import MButton from 'src/components/MButton/index.vue';
import { countryHash } from 'src/utils/countryData';
import { use18n, useIns, useStore } from 'src/utils/v2_helper/common';
import { ref, computed, watch, onMounted } from 'vue';
import { callGoogleCaptcha } from 'src/utils/common';
import { getCaptchaVerify, getLoginCaptcha, getUserInfo, guestBuyerMerge } from 'src/api/login';
import { useCountDown } from 'src/utils/hooks/use-countdown';
import { useRoute, useRouter } from 'src/utils/v2_helper/router';
import { useRetry } from 'src/utils/base';
import { useLoading } from 'src/utils/hooks/loading';
import { useVerify } from './useVerify';
import { useChooseCountry } from './useChooseCountry';
import { useErrMsg } from './useErrMsg';

const app = useIns();
const store = useStore();
const route = useRoute();
const router = useRouter();
const { hide, loading } = useLoading();
const { $t } = use18n();
const { captcha, typeTip, channel, verifing, verifyErrmsg } = useVerify();
const { number, start, state: countdownState, reset } = useCountDown(60);
const {
  countryName,
  countryCode,
  changeCountry,
  searchText,
  showCountry,
  chooseCountryVisible,
} = useChooseCountry();
const { e } = useErrMsg();
const sending = ref(false);
const phone = ref('');
const pageState = ref('init'); // init / verify
const errmsg = ref('');

const Menu = computed(() => store.state.Menu);
const disableInput = computed(() => (pageState.value === 'verify' || !!Menu.value.account));
const isCheckPass = computed(() => {
  if (phone.value.trim().length > 0) {
    // 印尼原有的验证
    if (countryCode.value === '+62') {
      if (
        new RegExp('^8.*$').test(phone.value) &&
        phone.value.length >= 8 &&
        phone.value.length < 15
      ) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        errmsg.value = '';
        return true;
      }
      if (!new RegExp('^8.*$').test(phone.value)) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        errmsg.value = $t('login.errorMsg1'); // 'Nomor telepon harus dimulai dengan 8';
        return false;
      }
      if (phone.value.length < 8) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        errmsg.value = $t('login.errorMsg2'); // 'Nomor telepon minimal harus 8 digit';
        return false;
      }
    } else if (phone.value.length < 4) {
      // 其他国家验证
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      errmsg.value = $t('login.errorMsg4', [4]);
      return false;
    }
    if (phone.value.length > 15) {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      errmsg.value = $t('login.errorMsg5', [15]);
      return false;
    }
    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    errmsg.value = '';
    return true;
  }
  return false;
});

async function buildParams() {
  const googleCaptcha = await callGoogleCaptcha();
  return {
    app: 'MenuBuyer',
    clientType: '1',
    googleCaptcha,
    expire: true,
    expireTime: 60,
    address: `${countryCode.value}${phone.value}`,
    countryCode: countryCode.value,
    type: channel.value,
    situation: 'LOGIN_OR_REGISTER',
    language: store.state.Menu.language === 'id-ID' ? 'id' : 'en',
    source: 'MenuBuyer',
  };
}

async function onSend() {
  if (!isCheckPass) return;
  reset();
  errmsg.value = '';
  sending.value = true;
  try {
    const params = await buildParams();
    const res = await getLoginCaptcha(params);
    if (res.success) {
      if (!countdownState.value) start();
      pageState.value = 'verify';
    } else {
      reset();
      errmsg.value = e[res.code] || $t('login.errorMsg3');
    }
  } catch (error) {
    reset();
    console.log(error);
  } finally {
    sending.value = false;
  }
}

function resend() {
  channel.value = 'SMS';
  onSend();
}

async function verify() {
  loading();
  // call verify
  try {
    const _p = await buildParams();
    const params = { ..._p, captcha: captcha.value };
    const verifyRes = await getCaptchaVerify(params);
    if (!verifyRes.success) {
      verifyErrmsg.value = $t('login.verifyerrorMsg1');
      return;
    }
    await store.dispatch('Menu/setToken', verifyRes.data);
    localStorage.setItem('token', verifyRes.data);

    // call userinfo
    const userRes = await useRetry(getUserInfo);
    if (!userRes.success) {
      verifyErrmsg.value = 'System Error';
      return;
    }
    await store.dispatch('Menu/setUserInfo', userRes.data || {});
    const url = route.params.store;
    // 如果存在redirect，使用redirect跳转
    const { redirect } = route.query;
    if (redirect) {
      router.push({ path: `/${url}/${redirect}` });
      return;
    }
    if (app.toLoginPath === 'user') {
      router.push({
        path: `/${url}/user/order-history`,
      });
    } else if (app.isFullDineIn) {
      router.push({ path: `/${url}/cart_confirm` });
    } else {
      router.push({ path: `/${url}/checkout` });
    }
  } catch (error) {
    console.log('Verify Error:', error);
  } finally {
    hide();
  }
}

watch(captcha, (v) => {
  if (v.length === 4) verify();
});


onMounted(() => {
 let account = Menu.value.account || '';
 account = String(account)
  if (account.startsWith('62')) {
    account = account.replace('62', '');
  }
  phone.value = account;
})
</script>
<style lang="scss">
.login_box {
  padding: 80px 24px 24px;
  background: $grayBg;

  .message-box {
    height: 48px;
    border-radius: 8px;
    align-items: center;
    gap: 10px;
    padding: 8px;
    background-color: #eeeeee;
    margin-bottom: 12px;
  }
  .message-text {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
  }

  .img-icon {
    width: 24px;
    height: 24px;
  }
  .errmsg {
    font-size: 12px;
    color: $negative;
    margin-top: 4px;
  }
  &_submit {
    width: 100%;
    margin-top: 32px;
  }
  &_tips {
    font-size: $font-size-1;
    text-align: center;
    margin-top: 8px;
    a {
      color: $primary;
    }
  }
  .prepend {
    padding: 0 13px;
    height: 100%;
    background: $button-bg;
    align-self: stretch;
    display: flex;
    align-items: center;
    color: $grayFont;
    border-right: 1px solid $border;
    .countryIcon {
      font-size: 24px;
      margin-right: 2px;
    }
  }
}

// choose country dialog
.chooseCountry {
  height: 60vh;
  background: #fff;
  .choose-prepend {
    padding-left: 12px;
    display: flex;
  }
  .choose-after {
    padding-right: 12px;
    display: flex;
  }

  .head {
    padding: 15px 15px 0 15px;
    font-size: 14px;
    font-weight: 800;
    position: relative;

    .close {
      position: absolute;
      right: 15px;
      top: 8px;
      font-size: 20px;
      color: $dark;
      cursor: pointer;
    }
  }

  .searchText {
    margin: 0 15px;
  }

  .closeSearch {
    color: #fff;
    background: #9ca3af;
    font-size: 14px;
    border-radius: 50%;
    padding: 2px;
  }

  .countryList {
    margin: 8px 0 0 0;
    height: calc(100% - 100px);
    overflow: auto;
    font-size: 14px;

    .countryItem {
      margin: 0;
      padding: 15px;
      position: relative;

      .iconfont {
        position: absolute;
        right: 15px;
        bottom: 15px;
        font-size: 16px;
        color: $dark;
        font-weight: 700;
        background: #f3f4f6;
        display: none;
      }

      &.curr {
        background: #f3f4f6;

        .iconfont {
          display: inline-block;
        }
      }
    }
  }
}
</style>
